import {
  Datagrid,
  EmailField,
  FunctionField,
  LinearProgress,
  NumberField,
  ReferenceField,
  TextField,
} from 'react-admin';
import ListWidget from './ListWidget';
import { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export default function MailCapStatusWidget(): ReactElement {
  return (
    <ListWidget
      title="Merchant Budget Usage"
      resource="merchant_spendings"
      queryOptions={{ meta: { prefetch: ['merchant'] } }}
      defaultSort={{ field: 'percent_spent', order: 'DESC' }}
    >
      <Datagrid
        bulkActionButtons={false}
        sx={{
          '& .MuiTableCell-root': {
            textAlign: 'left',
          },
        }}
      >
        <ReferenceField label="Merchant Name" source="id" reference="merchants">
          <TextField source="attributes.merchant_name" />
        </ReferenceField>
        <ReferenceField label="Merchant Email" source="id" reference="merchants" link={false}>
          <EmailField label="Primary contact email" source="attributes.email" />
        </ReferenceField>
        <ReferenceField label="Merchant Budget" source="id" reference="merchants" link={false}>
          <NumberField
            label="Monthly Budget"
            source="attributes.monthly_budget"
            options={{ style: 'currency', currency: 'AUD' }}
          />
        </ReferenceField>
        <NumberField
          label="Billed This Month"
          source="attributes.billed"
          options={{ style: 'currency', currency: 'AUD' }}
        />
        <FunctionField
          label="Spent This Month"
          render={(record) => {
            const percent = record?.attributes?.percent_spent ?? 0;
            let color: 'primary' | 'warning' | 'error' = 'primary';
            if (percent > 100) color = 'error';
            else if (percent > 75) color = 'warning';
            return (
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <LinearProgress
                  variant="determinate"
                  value={Math.min(percent, 100)}
                  color={color}
                  sx={{ width: 100, height: 10, borderRadius: 5 }}
                />
                <Typography variant="body2" sx={{ minWidth: 40 }}>
                  {percent.toFixed(0)}%
                </Typography>
              </Box>
            );
          }}
        />
      </Datagrid>
    </ListWidget>
  );
}
